<template>
  <PageLayout
    title="Privacy Policy"
    subtitle="Your privacy is important to us. This policy outlines how we collect, use, and protect your personal information."
    :last-updated="content.lastUpdated"
    :show-c-t-a="true"
  >
    <div class="space-y-8">
      <LegalSection
        v-for="section in content.sections"
        :key="section.id"
        :title="section.title"
      >
        <div v-html="section.content"></div>
      </LegalSection>
    </div>
  </PageLayout>
</template>

<script setup>
import PageLayout from '@/components/layout/PageLayout.vue';
import LegalSection from '@/components/ui/LegalSection.vue';
import { privacyContent } from '@/data/privacy';

const content = privacyContent;
</script>
